<script setup lang="ts">
import { MiscTeleports } from '#components';
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <MiscTeleports />
  </UApp>
</template>
